import LoginFormLayout from "./loginFormLayout";
import { useCallback } from "react";
import BannerLayout from "../../layouts/bannerLayout";

const LoginLayout = () => {
    const contactAdmin = useCallback(() => {
        window.open('https://wa.link/ly7zff', '_blank');
    }, []);

    return (
        <>
            <BannerLayout 
                title="Empowering Your Travel Quotations"
                description=""
                children={<LoginFormLayout contactAdmin={contactAdmin}/>}
                actionText="Contact Admin"
                action={contactAdmin}
            />
        </>
    );
}

export default LoginLayout;